import React from "react";

interface InfoRowProps {
  label?: string;
  value?: string | number | null | React.ReactNode;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  return (
    <div className="flex flex-col">
      {label && (
        <span className="text-xs uppercase text-gray-500">
          {label}
        </span>
      )}

      <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
        {value ?? "—"}
      </span>
    </div>
  );
};

export default InfoRow;
